import { render, staticRenderFns } from "./lkuKoranEkspedisi.vue?vue&type=template&id=4d7b355d"
import script from "./lkuKoranEkspedisi.vue?vue&type=script&lang=js"
export * from "./lkuKoranEkspedisi.vue?vue&type=script&lang=js"
import style0 from "./lkuKoranEkspedisi.vue?vue&type=style&index=0&id=4d7b355d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports